<template>
  <a-card>
    <div>
      <b
        ><span :style="{ color: '#F15A22' }"
          >Please Upload the required documents.</span
        ></b
      ><br />
      <i>
        <span>Accepted file types: JPG, JPEG, PNG, PDF</span><br />
        <span>maximum file size: 5MB each</span></i
      >
    </div>
    <br /><br />
    <div class="cardBody">
      <a-form>
        <base-input
          v-for="(file, i) in formData.files"
          :key="i"
          :required="!optionalFilesCode.includes(file.code)"
        >
          <!-- Add the label styling class manually -->
          <template #label>
            <label class="form-control-label">
              {{ file.name }}
              <i v-if="optionalFilesCode.includes(file.code)"> (If Applicable)</i>
              <span v-if="!optionalFilesCode.includes(file.code)" class="text-danger">*</span>
            </label>
          </template>

          <br />
          <a-upload
            :file-list="formData.files[i].file"
            :before-upload="(file) => beforeUpload(file, i)"
            :remove="(file) => handleRemove(file, i)"
            :custom-request="() => {}"
          >
            <a-button><a-icon type="upload" /> Select File</a-button>
          </a-upload>
          <div v-if="formData.files[i].error" class="text-danger mt-1">
            Field is required
          </div>
        </base-input>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
export default {
  props: {
    data: {
      type: Object,
    }
  },
  name: 'UploadDocuments',
  data() {
    return {
      formData: {
        files: [],
      },
      isCoop: false,
      isPartnerCorp: false,
      isProf: false,
      isSoleProp: false,
      optionalFilesCode: ['BIR_TAX'],
      memberTypeId: null,
      subMemberTypeId: null,
      acceptedFileTypes: ['image/jpeg', 'image/png', 'application/pdf'],
      maxFileSize: 5 * 1024 * 1024
    };
  },
  methods: {
    beforeUpload(file, value) {
      const isJpgOrPng = this.acceptedFileTypes.includes(file.type);
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG, JPEG, PNG, PDF file!');
        return false;
      }

      // Check if filesize is > (n)mb
      const fileSize = file.size <= this.maxFileSize;
      if (!fileSize) {
        this.$message.error('Image must smaller than 5MB!');
        return false;
      }

      this.formData.files[value].file = [file];
      this.$emit('update:files', this.formData.files);
      this.formData.files[value].error = false;
      return false;
    },
    handleRemove(file, value) {
      this.formData.files[value].file = [];
      this.$emit('update:files', this.formData.files);
    },
    async fetchUploadTypes() {
      let memberTypeId = this.data.memberTypeId;
      let subMemberTypeId = this.data.subMemberTypeId;

      const token = this.$route.query.token;
      if(token){
        const tokenResponse = await HTTPRequest.postRequest('/api/v2/clp_member_accounts/verify_token', 
        { token: token })

        memberTypeId = tokenResponse.data.memberTypeId;
        subMemberTypeId = tokenResponse.data.subMemberTypeId;
      }
      
      // const endpoint = `/api/v2/member_types/${memberTypeId}/upload_types`;
      const endpoint = `/api/v2/clp_members/member_upload_type_mapping`;
      const response = await HTTPRequest.getRequest(endpoint, 
      {
        member_type_id: memberTypeId, 
        sub_member_type_id: subMemberTypeId,
        targeted_member_type_id: null
      });

      const { data } = response;
      
      if (data && data.length > 0) {
        let f = data;
        let fileList = [];
        let x = 0;

        while (x < data.length) {
          f[x].file = [];
          fileList.push(f[x]);
          x++;
        }

        this.formData.files = fileList;
      }
    },
    async fetchFormData(data) {
      // if (data.files.length > 0) {
      //  this.formData.files = data.files;
      // }

      // for validation purposes
      if (data.files && data.files.length > 0) {
        this.formData.files = data.files.map(f => ({ ...f, file: f.file || [] }));
      }

      this.optionalFilesCode = data.optionalFilesCode;
      if (data.files.length === 0) {
        await this.fetchUploadTypes();
      }
    }
  },
  async created() {
    this.fetchFormData(this.data);
  },
  watch: {
    // it will update based on what changes from parent
    'data.optionalFilesCode': {
      immediate: true,
      handler(newVal) {
        this.optionalFilesCode = newVal || [];
      },
    }
  },
};
</script>

<style scoped></style>
